/**
 * Copyright (c) 2026 Finorda Pty Ltd
 * All rights reserved.
 *
 * This file is part of the Finorda platform.
 * Unauthorised copying, modification or
 * distribution of this software is
 * strictly prohibited.
 *
 * Proprietary and confidential.
 * Governed by Queensland law, Australia.
 */

/**
 * FilterBar - Search input, supplier filter dropdown, show archived checkbox.
 * Extracted from PurchaseOrders page for POG-TD-009.
 */
function FilterBar({ searchTerm, onSearchChange, supplierFilter, onSupplierFilterChange, supplierMapping, showArchived, onShowArchivedChange }) {
  return (
    <div style={{ marginBottom: '20px', display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
      <input
        type="text"
        placeholder="Search by PO #, job #, supplier..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        data-testid="search-input"
        style={{
          flex: 1, minWidth: '250px', padding: '12px 16px', fontSize: '14px',
          border: '1px solid #d1d5db', borderRadius: '6px', outline: 'none'
        }}
      />
      <select
        value={supplierFilter}
        onChange={(e) => onSupplierFilterChange(e.target.value)}
        data-testid="supplier-filter-select"
        style={{
          padding: '12px 16px', fontSize: '14px',
          border: '1px solid #d1d5db', borderRadius: '6px', minWidth: '200px'
        }}
      >
        <option value="">All Suppliers</option>
        {supplierMapping.map(s => (
          <option key={s.supplier_number} value={s.supplier_number}>
            {s.supplier_number} - {s.name}
          </option>
        ))}
      </select>
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#6b7280', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={showArchived}
          onChange={(e) => onShowArchivedChange(e.target.checked)}
          data-testid="checkbox-show-archived"
          style={{ width: '16px', height: '16px' }}
        />
        Show Archived
      </label>
    </div>
  )
}

export default FilterBar
